export default __webpack_public_path__ + "static/media/Select_force_change.f4c23c0b.svg";